export default __webpack_public_path__ + "static/media/android-opera-instructions.ab239e74.jpeg";